import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { MediaQuery } from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

export const NewsletterCard = styled.form`
  overflow: hidden;
  padding: 15px 30px 30px 30px;

  img {
    width: inherit;
    padding-bottom: 30px;
  }

  button {
    margin-top: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  ${MediaQuery.S_AND_DOWN} {
    padding: 15px 20px 20px 20px;
  }
`;

export const Title = styled.p`
  ${Typography.XXXL_BOLDER};
  color: ${props => props.contentColor};
  margin: 15px 0 0 0;
`;

export const Description = styled.p`
  ${Typography.M};
  height: 70px;
  color: ${props => props.contentColor};
  margin: 15px 0 30px 0;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 10px;
  color: ${Color.WHITE};
`;
